export default __webpack_public_path__ + "c88c3dbffa820cb3dfa297a09e4d10b5.png";